<template>
  <div class="workbench-work-packages-wrapper">

    <TMoveToDialog 
      v-if="prefix !== 'b' && prefix !== 'c' && move_to_element" 
      :folders="getWBObjects({ type: 'wfolders' })" 
      :current_folder="current_folder" 
      :item="move_to_element"
      :item_type="move_to_element_type"
      folder_type="wfolder"
      @cancel="move_to_element = false;"
      @move="moveWFolder($event)"
    />

    <transition name="dialog_slide">
      <router-view style="z-index: 20"/>
    </transition>
    <div class="workbench-search-wrapper">
      <div class="workbench-search-wrapper-top">
        <div class="workbench-search-wrapper-top-left">
            <div v-if="prefix !== 'b' && prefix !== 'c' && current_folder" class="folder-breadcrumbs">
              <TBreadcrumbs 
                  :breadcrumbs="folder_breadcrumbs"
                  root_name="Home"
                  :is_root="active_wfolder_id === 'last-updated'"
                  :current_folder_name="current_folder.name"
                  @clickRoot="$router.push({
                  name: `${location}WorkPackages`,
                  params: {
                    wfolder: 'last-updated',
                  }})"  
                  @clickBreadcrumb="$router.push({
                  name: `${location}WorkPackages`,
                  params: {
                    wfolder: $event.id,
                  }})"
                />
            </div>

          </div>
          <div class="workbench-search-wrapper-top-right">

            <v-progress-circular v-if="$store.state.WorkBenchLocal.workbench_variables.loading" indeterminate color="primary"/>

            <v-select
              class="workbench-search-icon-search"
              v-model="selected_icon"
              clearable
              clear-icon="close"
              @change="$event && $event != ''
                      ? workbenchSearchIcon($event): resetSearchBar()"
              :items="getWorkPackageIcons"
              label="Search for Icon"
              item-text="name"
            >
              <template v-slot:item="slotProps">
                <div class="workbench-search-icon-search-container">
                  <TIcon
                    :name="slotProps.item"
                    medium
                  />
                </div>
              </template>
              <template v-slot:selection="slotProps">
                <div class="workbench-search-icon-search-container">
                  <TIcon
                    :name="slotProps.item"
                    medium
                  />
                </div>
              </template>
            </v-select>

            <DropDown
              :items="filter_options"
              :value="$store.state.View.workbench_sorting"
              placeholder="Sorting"
              :translatable="true"
              :max_width="190"
              foreground_color="primary"
              :light="!$vuetify.theme.dark"
              @selected="updateWorkbenchSorting($event)"
            />

            <TIconButton
              v-if="$route.params.template_type === 'custom'"
              :color="$store.state.WorkBenchLocal.workbench_variables.search_all ? 'green': ''"
              tooltip="Search all subfolders"
              @clickIcon="updateSearchType()"
              icon="folder"
            /> 

            <SearchBar
              :is_live_emit="true"
              placeholder="Search for name"
              max_width="200"
              underscored
              @search="$event && $event != ''
                      ? workbenchSearch($event): resetSearchBar()
  "
              />
            </div>
            <!-- @search="workbenchSearch($event)" -->

      </div>
      <template v-if="workbench_variables.search === ''">
        <TText
          size="18"
          font_weight="600"
          :value="displayNoSearch"
        />
      </template>
      <template v-else>
        <TText
          size="18"
          font_weight="600"
          :value="'Search result{symbol} {searchVal}'"
          :value_props="{symbol: ':', searchVal: workbench_variables.search}"
        />
      </template>
    </div>

    <template v-if="workbench_variables.items_mini">

      <div class="mt-2 mb-2 pb-5" style="display:flex; width: 100%">
        <TContextMenu 
          :menu_items="[{key: 'rename', text: 'Rename'}, {key: 'move', text: 'Move'}, {key: 'delete', text: 'Delete', icon: 'bin-delete'}]" 
          v-for="(wfolder) in wfolders" 
          :key="`wfolder${wfolder.id}`" 
          @selectMenuItem="selectMenutItemWFolder($event, wfolder)"
        >
          <TFolder 
            :folder="wfolder" 
            prefix="" 
            :ref="`wfolder_${wfolder.id}`" 
            @click.native.stop="$router.push({
              name: `${location}WorkPackages`,
              params: {
                wfolder: wfolder.id,
              }})" 
            @renameFolder="renameFolder($event)" />
        </TContextMenu>
      </div>

      <div class="workbench-work-packages-display">
        <TContextMenu 
          :menu_items="[{key: 'move', text: 'Move'}]" 
          v-for="workpackage in workpackages"
          :key="`${workpackage.template_type}${workpackage.id}`"
          @selectMenuItem="selectMenutItemWorkpackage($event, workpackage)"
        >
        <!-- <v-hover
          >
          <template #default="hover_workpackage"> -->
        <WorkPackage
          class="ma-1 cursor-pointer"
          :workpackage="workpackage"
          :zoom="1"
          @click.native="$router.push({
              name: `WorkBenchWorkPackageEditor`,
              params: {
                workpackage_id: workpackage.id,
                template_type: workpackage.template_type
              }
            })"
          >
          <template #workpackage>
            <StandardBadge
              v-if="workpackage.template_type && workpackage.template_type !== 'custom'"
              :icon="workpackage.template_type === 'community'?'persons-two':'suitcase'"
              color="white"
              content_color="black"
              />
          </template>
        </WorkPackage>
      <!-- </template>
        </v-hover> -->
      </TContextMenu>
      </div>
    </template>
    <template v-else>
         <!-- Folder area -->
        <div class="mt-2 mb-2 pb-5" style="display:flex; width: 100%">
          <TContextMenu 
            :menu_items="[{key: 'rename', text: 'Rename'}, {key: 'move', text: 'Move'}, {key: 'delete', text: 'Delete', icon: 'bin-delete'}]" 
            v-for="(wfolder) in wfolders" 
            :key="`wfolder${wfolder.id}`" 
            @selectMenuItem="selectMenutItemWFolder($event, wfolder)"
          >
          <!-- :parent="wfolder.wfolder.id == active_wfolder_id ? false : wfolder.wfolder" -->
            <TFolder 
              :folder="wfolder"
              :parent="wfolder.wfolder ? (wfolder.wfolder.id == active_wfolder_id ? false : wfolder.wfolder) : false"
              prefix="" 
              :ref="`wfolder_${wfolder.id}`" 
              @click.native.stop="$router.push({
                name: `${location}WorkPackages`,
                params: {
                  wfolder: wfolder.id,
                }})" 
              @renameFolder="renameFolder($event)" />
          </TContextMenu>
        </div>
      <div class="workbench-search-content">
          <TContextMenu 
          :menu_items="[{key: 'move', text: 'Move'}]" 
          v-for="workpackage in workpackages"
          :key="`${workpackage.template_type}${workpackage.id}`"
          @selectMenuItem="selectMenutItemWorkpackage($event, workpackage)"
        >
        <v-hover
          >
          <template #default="hover_workpackage">
            <WorkBenchWorkPackage
              class="cursor-pointer font-weight-light"
              :color="workpackage.color"
              :text_color="workpackage.textcolor"
              width="192px"
              height="128px"
              margin="4px"
              footer="true"
              center_content="true"
              @click.native="$router.push({
                  name: `WorkBenchWorkPackageEditor`,
                  params: {
                    workpackage_id: workpackage.id,
                    template_type: workpackage.template_type
                  }
                })"
              >
                <template #header>
                  <WorkBenchWorkPackageHeader
                    :icon="workpackage.icon"
                    :token="workpackage.token"
                    :name="workpackage.name"
                    :text_color="workpackage.textcolor"
                    no_color_picker="true"
                    >
                    <template #text>
                      <div style="display: flex; flex-direction: column; height: 100%">
                        <div class="workbench-work-packages-wrapper-header">
                          <TText :text="`${workpackage.token}`" :color="workpackage.textcolor" />
                          <TText text="-" :color="workpackage.textcolor" />
                          <TText :text="`${workpackage.name}`" max_lines="1" :color="workpackage.textcolor" />
                        </div>
                        <TText v-if="workpackage.wfolder ? workpackage.wfolder.id != active_wfolder_id : false" :text="'/' + workpackage.wfolder.name" font_weight="300" size="9" align="center" :color="workpackage.textcolor" />
                      </div>
                      
                    </template>
                    <template #actions>
                      <StandardBadge
                        v-if="workpackage.template_type && workpackage.template_type !== 'custom'"
                        :icon="workpackage.template_type === 'community'?'persons-two':'suitcase'"
                        :zoom="1"
                        style="top: 0px; right: 0px"
                        color="white"
                        content_color="black"
                        />
                    </template>
                  </WorkBenchWorkPackageHeader>
                </template>
                <template #content>
                  <TFlex
                    justify_content="space-around"
                    >
                    <v-hover>
                      <template #default="hover_circle">
                      <TProgressCircle
                        :diameter="36"
                        :width="4"
                        :color="workpackage.textcolor === 'black'?'0,0,0':'255,255,255'"
                        :data="getProgressCircular(workpackage, 'steps')"
                        :show_icons="hover_workpackage.hover"
                        :show_values="hover_circle.hover"
                        />
                      </template>
                    </v-hover>
                    <v-hover>
                      <template #default="hover_circle">
                        <TProgressCircle
                          :diameter="36"
                          :width="4"
                          :color="workpackage.textcolor === 'black'?'0,0,0':'255,255,255'"
                          :data="getProgressCircular(workpackage, 'images')"
                          :show_icons="hover_workpackage.hover"
                          :show_values="hover_circle.hover"
                          />
                      </template>
                    </v-hover>
                    <TProgressCircle
                      :diameter="36"
                      :width="4"
                      :color="workpackage.textcolor === 'black'?'0,0,0':'255,255,255'"
                      :data="getProgressCircular(workpackage, 'values')"
                      :show_icons="hover_workpackage.hover"
                      />
                  </TFlex>
                </template>
                <template #footer>
                  <div>{{workpackage.updated.substring(0,16)}}</div>
                  <div>{{workpackage.owner.email}}</div>
                </template>
            </WorkBenchWorkPackage>
          </template>
        </v-hover>
      </TContextMenu>
      </div>
    </template>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { WorkBenchMixin } from '@/mixins/WorkBench.mixin.js';
import { WorkPackageWIPMixin } from '@/mixins/WorkPackageWIPMixin.mixin.js';
import SearchBar from '@/components/WorkPackageWIP/SearchBar.component.vue';
import DropDown from '@/components/WorkPackageWIP/DropDown.component.vue';
import TIconButton from '@/components/Taktify/TIconButton.component.vue';

import TFolder from '@/components/Taktify/TFolder.component.vue';
import TMoveToDialog from '@/components/Taktify/TMoveToDialog.component.vue';
import TBreadcrumbs from '@/components/Taktify/TBreadcrumbs.component.vue';
import TContextMenu from '@/components/Taktify/TContextMenu.component.vue';

  export default {
    props: [
      'location'
    ],
    mixins: [
      WorkBenchMixin,
      WorkPackageWIPMixin,
    ],

    components: {
      SearchBar,
      DropDown,
      TMoveToDialog,
      TBreadcrumbs,
      TContextMenu,
      TFolder,
      TIconButton
    },

    data: () => ({
      selected_icon: '',
      move_to_element: false,
      move_to_element_type: 'wfolders',
      filter_options: [
        'Updated date (asc)',
        'Updated date (desc)',
        'Created date (asc)',
        'Created date (desc)',
        'Name (asc)',
        'Name (desc)'
      ],
    }),

    beforeRouteLeave(to, from, next){
      this.updateWBLObject({
          path: [
            {workbench_variables: ''}
          ],
          update: {
            search: ''
          }
        });
        next();
    },

    created() {
      this.loadData(`&limit=16&offset=0`);
    },

    computed: {

      ...mapGetters('WorkBench', [
        'getParentFolders',
        'getWBObject',
      ]),

      displayNoSearch() {
        if(this.$store.state.WorkBench.all_loaded.includes(`${this.prefix}workpackages`)) {
          return 'All';
        }

        return this.$store.state.View.workbench_sorting;
      },

      active_wfolder_id(){
        const active_wfolder_id = this.$route.params.wfolder;
        if(active_wfolder_id === 'last-updated') {
          return active_wfolder_id
        }
        return parseInt(active_wfolder_id);
      },

      current_folder(){
        if (this.active_wfolder_id === 'last-updated') {
          return { name: 'Home', id: 'last-updated' };
        }
        return this.getWBObject({ type: 'wfolders', id: this.active_wfolder_id });
      },

      folder_breadcrumbs(){
        if (this.active_wfolder_id === 'last-updated') {
          return [];
        }
        const wb_object = this.current_folder;
        if (!wb_object) {
          return [];
        }
        return this.getParentFolders({type: 'wfolder', wb_object: wb_object}).reverse();
      },  

      wfolders(){
        // console.log(this.prefix)
        if (this.prefix !== 'b' && this.prefix !== 'c') {
          // console.log(this.location, this.getWBObjectsSearch({prefix: this.prefix, object_type: 'wfolders',object_type_short: 'w', folder: this.active_wfolder_id}), this.$store.state.WorkBench)
          return this.getWBObjectsSearch({prefix: this.prefix, object_type: 'wfolders',object_type_short: 'w', folder: this.active_wfolder_id});
        }
        return [];
      },

      workpackages() {
        let wps = this.getWBObjectsSearch({prefix: this.prefix, object_type: 'workpackages', object_type_short: 'w', folder: this.active_wfolder_id});
        let sort_by;
        let reverse;
        switch (this.$store.state.View.workbench_sorting) {
          case 'Created date (asc)':
            sort_by = 'created';
            reverse = false;
            break;
          case 'Created date (desc)':
            sort_by = 'created';
            reverse = true;
            break;
          case 'Updated date (asc)':
            sort_by = 'updated';
            reverse = false;
            break;
          case 'Updated date (desc)':
            sort_by = 'updated';
            reverse = true;
            break;
          case 'Name (asc)':
            sort_by = 'name';
            reverse = false;
            break;
          case 'Name (desc)':
            sort_by = 'name';
            reverse = true;
            break;
          default:
            sort_by = 'updated';
        }

        this.sortObjectArrayByValueOfKey(wps, sort_by);

        if(reverse) wps.reverse();

        return wps;
      },
    },

    watch: {
      prefix() {
        this.loadData(`&limit=16&offset=0`);
      }
    },

    methods: {
      ...mapActions('View', [
        'setValue',
      ]),
      updateWorkbenchSorting(sorting) {
        localStorage.setItem('Workbench_Sorting', sorting);
        this.setValue({ key: 'workbench_sorting', value: sorting });
      },

      moveWFolder(payload){
        this.changeWBObjectFolder({
          url: [
            { [this.move_to_element_type]: payload.target.id }
          ],
          url_suffix: '/changeparent',
          update: {
            parent_id: payload.new_parent.id,
            folder_key: 'wfolders',
          }
        }).then(() => {
          this.move_to_element = false;
        });
      },

      selectMenutItemWFolder(payload, wfolder){
        const item = payload.item;
        if (item.key === 'rename') {
          const folder = this.$refs[`wfolder_${wfolder.id}`][0];
          folder.startRenaming();
        } else if (item.key === 'delete') {
          this.deleteWBObject({
            url: [
              { wfolders: wfolder.id}
            ]
          });
        } else if (item.key === 'move') {
          this.move_to_element = wfolder;
          this.move_to_element_type = 'wfolders';
        }
      },

      selectMenutItemWorkpackage(payload, workpackage){
        const item = payload.item;
        if (item.key === 'move') {
          this.move_to_element = workpackage;
          this.move_to_element_type = 'workpackages';
          // console.log(workpackage, this.getWBObjects({ type: 'wfolders' }), this.current_folder, this.active_wfolder_id)
        }
      },

      renameFolder(folder){
        this.updateWBObject({
          url: [
            { [`${this.prefix}wfolders`]: folder.id }
          ],
          update: {
            name: folder.name
          }
        });
      },

      workbenchSearch(val){
        this.selected_icon = ''
        if (val && val !== '') {
          this.loadData(`&search=${encodeURIComponent(val)}`).then(() => {
            this.updateWBLObject({
            path: [
              {workbench_variables: ''}
            ],
            update: {
              search: val
            }
          })
          });
        }
        // if (val) {
        //   this.loadData(`&search=${val}`);
        // } else if(val == '') {
        //   this.loadData(`&offset=0`);
        // }
        // this.updateWBLObject({
        //     path: [
        //       {workbench_variables: ''}
        //     ],
        //     update: {
        //       search: val
        //     }
        //   })
      },

      workbenchSearchIcon(val){
        if (val && val !== '') {
          this.loadData(`&icon=${encodeURIComponent(val)}`).then(() => {
            this.updateWBLObject({
            path: [
              {workbench_variables: ''}
            ],
            update: {
              search: val
            }
          })
          });
        }
        // if (val && val !== '') {
        //   this.loadData(`&icon=${val}`);
        // }
        // this.updateWBLObject({
        //     path: [
        //       {workbench_variables: ''}
        //     ],
        //     update: {
        //       search: val || ''
        //     }
        //   })
      },

      updateSearchType() {
        this.updateWBLObject({
          path: [
            {workbench_variables: ''}
          ],
          update: {
            search_all: !this.$store.state.WorkBenchLocal.workbench_variables.search_all
          }
      })
        localStorage.setItem('WORKBENCH_search_all_subfolders', JSON.stringify(this.$store.state.WorkBenchLocal.workbench_variables.search_all));
      },

      loadData(url_suffix){
        return new Promise((resolve) => {
          this.updateWBLObject({
            path: [
              {workbench_variables: ''}
            ],
            update: {
              loading: true
            }
          });
          // if (['b', 'c'].includes(this.prefix) || this.isWBObjEmpty('workpackages')) {
            let promises = [];
            promises.push(this.requestWBObject({
              url: [
                {[`${this.prefix}workpackages`]: ''},
                {showWithEntitiesNormalized: ''}
              ],
              url_suffix:url_suffix
            }))
            if(this.prefix !== 'b' && this.prefix !== 'c'){
              promises.push(this.requestWBObject({
                url: [
                  {[`${this.prefix}wfolders`]: ''},
                  {showWithEntitiesNormalized: ''}
                ],
                url_suffix: url_suffix
              }));
            }
            Promise.all(promises).then(() => {
              this.updateWBLObject({
                path: [
                  {workbench_variables: ''}
                ],
                update: {
                  loading: false
                }
              });
              resolve();
            });
          // }
        });
      }
    }
  }
</script>
<style scoped>
.workbench-search-wrapper {
  width: 100%;
  padding: 20px 8px;
  background-color: var(--v-color-7-base);
  height: 120px;
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
}
.workbench-search-wrapper-top {
  width: 100%;
  display: flex;
  justify-content: space-between;
  max-height: 40px;
  grid-gap: 16px;
}
.workbench-search-wrapper-top-left {
    display: flex;
    justify-content: flex-start;
}

.workbench-search-wrapper-top-right {
  display: flex;
  justify-content: flex-end;
}
.workbench-work-packages-wrapper {
  height:100%;
  width: 100%;
  flex-wrap: wrap;
  padding: 2px;
  flex-direction: column;
}
.workbench-search-icon-search {
  max-width: 160px;
  max-height: 32px;
  padding-top: 0 !important;
  margin-top: 0 !important;
}
.workbench-search-icon-search-container {
  width: 100%;
  display: flex;
  justify-content: center;
}
.workbench-search-wrapper-searchbar {
  width: 50%;
  height: 40px;
  align-self: center;
}
.workbench-work-packages-wrapper-header {
  display: flex;
  grid-gap: 4px;
}
.workbench-work-packages-display {
  display: flex;
  flex-wrap: wrap;
}
.workbench-search-content {
  height: calc(100% - 120px);
  overflow-y: scroll;
  overflow-x: hidden;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
</style>
